import dayjs from 'dayjs'
import React, { FC } from 'react'

import { LoadingIndicator, Table } from 'Components'
import { useFetchLatestAnamnesis } from 'Pages/AnamnesisPage/AnamnesisPage'
import { ProgramTypes } from 'Pages/AnamnesisPage/types'
import { getAnamnesisDataSelector } from 'ReduxStore/anamnesis'
import { coreBackendUserInfoSelector, coreBackendUserSelector } from 'ReduxStore/coreBackendUser'
import { useAppSelector } from 'ReduxStore/hooks'
import { currentProgramSelector } from 'ReduxStore/programs'

const CurrentProgramInfo: FC = () => {
  useFetchLatestAnamnesis()

  const currentProgram = useAppSelector(currentProgramSelector)

  const anamnesis = useAppSelector(getAnamnesisDataSelector)

  const { hasPrograms } = useAppSelector(coreBackendUserInfoSelector)

  const { isExisting } = useAppSelector(coreBackendUserSelector)

  const isLoading =
    (currentProgram === undefined && !(isExisting && !hasPrograms)) || (!!currentProgram?.anamnesisId && !anamnesis)

  if (isLoading) {
    return (
      <div className="mt-3 basiccard p-3">
        <LoadingIndicator />
      </div>
    )
  }

  if (!currentProgram) {
    return <div className="mt-3 basiccard p-3">Aktuell ist kein Programm aktiv.</div>
  }

  const isLoseWeight = anamnesis?.activeProgramType === ProgramTypes.LOSE_WEIGHT

  const programTypeLabel = isLoseWeight ? 'Gewicht abnehmen' : 'Gewicht halten'

  const rows: Array<React.ReactNode>[] = [
    ['Programmart', programTypeLabel],
    ['Startdatum', dayjs(currentProgram.startDate).format('L')]
  ]

  if (isLoseWeight && currentProgram.goalDate) {
    rows.push(['Zieldatum', dayjs(currentProgram.goalDate).format('L')])
  }

  rows.push(['Gewicht bei Programmstart', `${currentProgram.startValue} kg`])

  if (isLoseWeight) {
    rows.push(['Zielgewicht', `${currentProgram.goalValue} kg`])
  }

  return (
    <div className="basiccard p-3 mt-3">
      <Table theme="profile" titleRow={['Aktives Programm', '']} rows={rows} />
    </div>
  )
}

export default CurrentProgramInfo
